<template>
  <div class="cs-simple-table">
    <el-table
      :data="data"
      style="width: 100%"
      v-bind="$attrs"
      v-on="$listeners"
      ref="table"
      :tooltip-effect="tooltipEffect"
    >
      <el-table-column
        v-for="item in columns"
        :key="item.dataIndex"
        :type="item.type"
        :item="item.index"
        :columnKey="item.columnKey"
        :label="item.label"
        :prop="item.dataIndex"
        :width="item.width"
        :minWidth="item.minWidth"
        :fixed="item.fixed"
        :renderHeader="item.renderHeader"
        :sortable="item.sortable"
        :sortBy="item.sortBy"
        :sortOrders="item.sortOrders"
        :resizable="item.resizable"
        :formatter="formatter(item.formatter)"
        :showOverflowTooltip="item.showOverflowTooltip"
        :align="item.align"
        :headerAlign="item.headerAlign"
        :className="item.className"
        :labelClassName="item.labelClassName"
        :selectable="item.selectable"
        :reserveSelection="item.reserveSelection"
        :filters="item.filters"
        :filterPlacement="item.filterPlacement"
        :filterMultiple="item.filterMultiple"
        :filterMethod="item.filterMethod"
        :filteredValue="item.filteredValue"
      >
        <template v-if="item.slot" v-slot="scope">
          <slot
            :name="item.slot"
            :row="scope.row"
            :column="scope.column"
            :$index="scope.$index"
          />
        </template>
        <template v-if="item.slotHeader" v-slot:header="scope">
          <slot
            :name="item.slotHeader"
            :column="scope.column"
            :$index="scope.$index"
          />
        </template>
      </el-table-column>
      <el-table-column
        :width="operationsWidth"
        v-if="operations"
        label="操作"
        header-align="right"
      >
        <template v-slot="{ row, column, $index }">
          <column-operations
            @setWidth="setWidth"
            :row="row"
            :column="column"
            :$index="$index"
            :operations="getOperations(row, column, $index)"
          />
        </template>
      </el-table-column>
    </el-table>
    <div class="cs-simple-table-pagination" v-if="pagination">
      <el-pagination
        background
        layout="total, sizes, prev, pager, next, jumper"
        :total="pagination.total"
        :current-page.sync="pagination.pageNum"
        :page-size.sync="pagination.pageSize"
        :page-sizes="pagination.pageSizes"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
      />
    </div>
  </div>
</template>

<script>
import ColumnOperations from "./column-operations.vue";
import { isEmpt, dateFormat } from "@/utils/utils";
const EMPT_TEXT = "- -";

export default {
  name: "CsSimpleTable",
  components: { ColumnOperations },
  props: {
    data: {
      type: Array,
      required: true,
    },
    columns: {
      type: Array,
      required: true,
    },
    pagination: {
      type: Object,
      required: false,
      default: undefined,
    },
    operations: {
      type: [Function, Array, Boolean],
      required: false,
      default: false,
    },
    tooltipEffect: {
      type: String,
      required: false,
      default: "light",
    },
  },
  data() {
    return {
      operationsWidth: "auto",
    };
  },
  methods: {
    getOperations(row, column, $index) {
      if (Array.isArray(this.operations)) {
        return this.operations;
      }
      return this.operations(row, column, $index);
    },
    setWidth(width) {
      if (
        typeof this.operationsWidth === "number" &&
        this.width < this.operationsWidth
      ) {
        return;
      }
      this.operationsWidth = width;
    },
    getTableData() {
      this.$emit("getTableData");
    },
    handleSizeChange(val) {
      this.pagination.pageNum = 1;
      this.pagination.pageSize = val;
      this.getTableData();
    },
    handleCurrentChange(val) {
      this.pagination.pageNum = val;
      this.getTableData();
    },
    formatter(formatter) {
      if (formatter === undefined) {
        return function (row, column, cellValue) {
          if (isEmpt(cellValue)) {
            return EMPT_TEXT;
          }
          return cellValue;
        };
      } else if (formatter === "date") {
        return function (row, column, cellValue) {
          if (isEmpt(cellValue)) {
            return EMPT_TEXT;
          }
          return dateFormat(cellValue, "date");
        };
      } else if (formatter === "datetime") {
        return function (row, column, cellValue) {
          if (isEmpt(cellValue)) {
            return EMPT_TEXT;
          }
          return dateFormat(cellValue, "full");
        };
      } else {
        return formatter;
      }
    },
    clearSelection() {
      return this.$refs.table.clearSelection(...arguments);
    },
    toggleRowSelection() {
      return this.$refs.table.toggleRowSelection(...arguments);
    },
    toggleAllSelection() {
      return this.$refs.table.toggleAllSelection(...arguments);
    },
    toggleRowExpansion() {
      return this.$refs.table.toggleRowExpansion(...arguments);
    },
    setCurrentRow() {
      return this.$refs.table.setCurrentRow(...arguments);
    },
    clearSort() {
      return this.$refs.table.clearSort(...arguments);
    },
    clearFilter() {
      return this.$refs.table.clearFilter(...arguments);
    },
    doLayout() {
      return this.$refs.table.doLayout(...arguments);
    },
    sort() {
      return this.$refs.table.sort(...arguments);
    },
  },
};
</script>

<style lang="scss" scoped>
.cs-simple-table-pagination {
  text-align: right;
  padding: 10px 0;
}
</style>
